import React from 'react';
import { FaqItem } from '../FaqItem';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../../data/content';
export function FaqSection() {
  return <section aria-labelledby="faq-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-94" data-mp="2kxfiqho1rgor">
      <div className="mx-auto max-w-3xl" data-id="element-95" data-mp="2fyccitwbz4f7">
        <SectionHeading id="faq-heading" title="Domande frequenti" data-id="element-96" data-mp="2fxaz4irue5ub" />
        <div className="mt-10 border-t border-brand-charcoal/12" data-id="element-97" data-mp="2txvltq0volt3">
          {faqs.map(faq => <FaqItem key={faq.question} {...faq} data-id="element-98" data-mp="2pws2uunja9nn" />)}
        </div>
      </div>
    </section>;
}